import { AxiosStatic, AxiosRequestConfig } from './types';
import Axios from './core/Axios';
import { extend } from './helpers/util';
import defaults from './defaults';
import mergeConfig from './core/mergeConfig';
import CancelToken from './cancel/CancelToken';
import Cancel, { isCancel } from './cancel/Cancel';

function createInstance(config: AxiosRequestConfig): AxiosStatic {
  const context = new Axios(config); // axios 实例
  const instance = Axios.prototype.request.bind(context); // instance 的this 绑定到实例context 上
  
  // 将context 的类型属性和原型属性拷贝到instance上
  extend(instance, context);
  return instance as AxiosStatic;
}

const axios = createInstance(defaults);

// 扩展静态属性
axios.create = function create(config) {
  return createInstance(mergeConfig(defaults, config))
};

axios.CancelToken = CancelToken;
axios.Cancel = Cancel;
axios.isCancel = isCancel;

axios.all = function all(promises) {
  return Promise.all(promises);
}

axios.spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  }
}

axios.Axios = Axios;

export default axios;
